export default __webpack_public_path__ + "static/media/CustomerCase11.c34c14e8.png";